import { GLOBAL_LOCALES } from '@repo/gatsby-localization-helpers';

type KlaviyoPublicMap = {
  publicKey: string;
  newsletterListId: string;
};

function petsafeLocaleToKlaviyoMap(locale: string): KlaviyoPublicMap {
  switch (locale?.toLowerCase()) {
    case GLOBAL_LOCALES.English.id:
      return { publicKey: 'QZrSEc', newsletterListId: 'WT6jim' };
    case GLOBAL_LOCALES.Australia.id:
      return { publicKey: 'StUrAt', newsletterListId: 'ThnuYA' };
    case GLOBAL_LOCALES.EnglishUK.id:
      return { publicKey: 'XsUue4', newsletterListId: 'RYb5hq' };
    case GLOBAL_LOCALES.FrenchBelgium.id:
      return { publicKey: 'Xauxic', newsletterListId: 'WnNe39' };
    case GLOBAL_LOCALES.Spanish.id:
      return { publicKey: 'XmZiaW', newsletterListId: 'U6Q4tK' };
    case GLOBAL_LOCALES.French.id:
      return { publicKey: 'XMjZpz', newsletterListId: 'SdXk7x' };
    case GLOBAL_LOCALES.Germany.id:
      return { publicKey: 'QRyNY8', newsletterListId: 'UL77iR' };
    case GLOBAL_LOCALES.EnglishIreland.id:
      return { publicKey: 'RYQpCX', newsletterListId: 'UXRC82' };
    case GLOBAL_LOCALES.Italian.id:
      return { publicKey: 'Rg86Cd', newsletterListId: 'Yaw7vN' };
    case GLOBAL_LOCALES.EnglishNetherlands.id:
      return { publicKey: 'QUEj6k', newsletterListId: 'VueEcd' };
    case GLOBAL_LOCALES.GermanSwitzerland.id:
      return { publicKey: 'Tktfem', newsletterListId: 'WLDKAT' };
    case GLOBAL_LOCALES.EnglishCanada.id:
      return { publicKey: 'XDFjfa', newsletterListId: 'XhJxKr' };
    default:
      console.warn('default hit: petsafeLocaleToKlaviyoMap', locale);
      return { publicKey: '', newsletterListId: '' };
  }
}

function sportdogLocaleToKlaviyoMap(locale: string): KlaviyoPublicMap {
  switch (locale?.toLowerCase()) {
    case GLOBAL_LOCALES.English.id:
      return { publicKey: 'VtUtmM', newsletterListId: 'TKaQ6U' };
    case GLOBAL_LOCALES.Australia.id:
      return { publicKey: 'T3gdMq', newsletterListId: 'YwWSMj' };
    case GLOBAL_LOCALES.EnglishUK.id:
      return { publicKey: 'WGXZgf', newsletterListId: 'YgGBPg' };
    case GLOBAL_LOCALES.French.id:
      return { publicKey: 'SZAXGj', newsletterListId: 'UyJkcY' };
    default:
      console.warn('default hit: sportdogLocaleToKlaviyoMap', locale);
      return { publicKey: '', newsletterListId: '' };
  }
}

export function localeToKlaviyoPublicMap(
  locale: string,
  site: string
): KlaviyoPublicMap {
  switch (site) {
    case 'petsafe':
      return petsafeLocaleToKlaviyoMap(locale);
    case 'sportdog':
      return sportdogLocaleToKlaviyoMap(locale);
  }
}
